import { render, staticRenderFns } from "./PracticeApplicationsReceived.vue?vue&type=template&id=15ffc3fd&"
import script from "./PracticeApplicationsReceived.vue?vue&type=script&lang=js&"
export * from "./PracticeApplicationsReceived.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports